import React, { useEffect, useState } from "react";

// Função utilitária para substituir placeholders
function substituirPlaceholdersMensagem(
  texto,
  lead = {},
  agendamentos = [],
  usuarios = [],
  dentistas = [],
  procedimentos = [],
) {
  // LOGS PARA DEBUG COMPLETO
  console.log("==== DEBUG MensagemRapida ====");
  console.log("lead:", lead);
  console.log("usuarios:", usuarios);
  console.log("lead.usuario_criador_id:", lead?.usuario_criador_id);

  if (Array.isArray(usuarios)) {
    console.log(
      "Usuários IDs e nomes:",
      usuarios.map((u) => ({ id: u.id, nome: u.nome })),
    );
  }
  // Tenta encontrar o captador
  const captadorObj = usuarios.find(
    (u) => String(u.id) === String(lead.usuario_criador_id),
  );
  console.log("captadorObj:", captadorObj);
  const captador = captadorObj?.nome || "Não informado";
  // Só o primeiro nome!
  const captadorPrimeiroNome = captador.split(" ")[0] || "Não informado";
  console.log("captador (primeiro nome):", captadorPrimeiroNome);

  // Os outros dados
  const paciente = lead?.nome_lead || "Não informado";
  console.log("paciente:", paciente);

  const profissionalObj = dentistas.find(
    (d) => String(d.id) === String(lead.id_dentista),
  );
  console.log("profissionalObj:", profissionalObj);
  const profissional = profissionalObj?.profissional || "Não informado";

  const procedimentoObj = procedimentos.find(
    (p) => String(p.id) === String(lead.id_procedimento),
  );
  console.log("procedimentoObj:", procedimentoObj);
  const procedimento = procedimentoObj?.nome || "Não informado";

  const agendamentosLead = agendamentos.filter(
    (a) =>
      String(a.lead_id) === String(lead.id) &&
      ["Agendado", "Reagendado"].includes(a.status_agendamento),
  );
  console.log("agendamentosLead:", agendamentosLead);

  // Ordena por data e pega o último (mais recente)
  const ultimoAgendamento = agendamentosLead.sort(
    (a, b) => new Date(b.data_agendamento) - new Date(a.data_agendamento),
  )[0];

  // Data e hora formatadas
  let data_agendamento = "Não informado";
  if (ultimoAgendamento && ultimoAgendamento.data_agendamento) {
    const data = new Date(ultimoAgendamento.data_agendamento);
    data_agendamento =
      data.toLocaleDateString("pt-BR") +
      " " +
      data.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  }
  console.log("data_agendamento:", data_agendamento);

  // Substitui todos os placeholders no texto
  const textoFinal = texto
    .replace(/\[captador\]/gi, captadorPrimeiroNome)
    .replace(/\[paciente\]/gi, paciente)
    .replace(/\[profissional\]/gi, profissional)
    .replace(/\[procedimento\]/gi, procedimento)
    .replace(/\[data_agendamento\]/gi, data_agendamento);

  console.log("textoFinal:", textoFinal);
  console.log("=============================");

  return textoFinal;
}

const tipos = [
  "Boas Vindas",
  "Quebra de Objeção",
  "Agradecimento",
  "Lembrete",
  "Finalização",
  "Informativo",
];

export default function MensagemRapida({
  empresaId,
  onSeleciona,
  leadSelecionada,
  agendamentos = [],
  usuarios = [],
  dentistas = [],
  procedimentos = [],
}) {
  const [mensagens, setMensagens] = useState([]);
  const [tipoSelecionado, setTipoSelecionado] = useState("");
  const [aberto, setAberto] = useState(false);
  const [mensagemPreview, setMensagemPreview] = useState("");

  useEffect(() => {
    if (empresaId) {
      fetch(
        `https://api.captacrm.com.br/api/mensagens-rapidas/empresa/${empresaId}`,
      )
        .then((r) => r.json())
        .then(setMensagens)
        .catch(() => setMensagens([]));
    }
  }, [empresaId]);

  const mensagensFiltradas = tipoSelecionado
    ? mensagens.filter((msg) => msg.tipo === tipoSelecionado)
    : [];
  const favoritas = mensagensFiltradas.filter((msg) => msg.favorita);
  const comuns = mensagensFiltradas.filter((msg) => !msg.favorita);

  // Quando seleciona mensagem, mostra preview
  const handleSeleciona = (texto) => {
    console.log("handleSeleciona chamada!");
    const textoFinal = substituirPlaceholdersMensagem(
      texto,
      leadSelecionada,
      agendamentos,
      usuarios,
      dentistas,
      procedimentos,
    );
    setMensagemPreview(textoFinal);
  };

  // Enviar (coloca na caixa de texto do chat para enviar pelo backend)
  const handleConfirmaEnviar = () => {
    console.log("handleConfirmaEnviar chamada!");
    if (mensagemPreview) {
      onSeleciona(mensagemPreview); // Preenche a caixa de texto do chat
      setMensagemPreview("");
      setAberto(false);
    }
  };

  // Cancelar preview
  const handleCancelarPreview = () => {
    console.log("handleCancelarPreview chamada!");
    setMensagemPreview("");
  };

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 14,
        boxShadow: "0 2px 10px #0002",
        padding: 14,
        marginBottom: 8,
        maxWidth: 420,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 6,
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: 15,
            color: "#226c56",
          }}
        >
          Mensagens Rápidas
        </div>
        <button
          onClick={() => {
            console.log("Botão de abrir/recolher clicado!");
            setAberto((a) => !a);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: 18,
            color: "#25d366",
            fontWeight: "bold",
            padding: 0,
          }}
          title={aberto ? "Recolher" : "Expandir"}
        >
          {aberto ? "−" : "+"}
        </button>
      </div>
      {aberto &&
        (mensagemPreview ? (
          <div style={{ marginBottom: 18 }}>
            <div
              style={{
                fontWeight: "bold",
                color: "#226c56",
                marginBottom: 8,
              }}
            >
              Pré-visualização da mensagem:
            </div>
            <div
              style={{
                maxHeight: 220,
                overflowY: "auto",
                background: "#e8f8f3",
                borderRadius: 8,
                padding: 12,
                marginBottom: 10,
                color: "#184c3a",
                fontSize: 14,
                whiteSpace: "pre-line",
                boxShadow: "0 2px 8px #25d36622",
              }}
            >
              {mensagemPreview}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
              }}
            >
              <button
                onClick={handleConfirmaEnviar}
                style={{
                  background: "#25d366",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 18px",
                  fontWeight: "bold",
                  fontSize: 15,
                  cursor: "pointer",
                  boxShadow: "0 2px 8px #25d36622",
                }}
              >
                Enviar pelo WhatsApp
              </button>
              <button
                onClick={handleCancelarPreview}
                style={{
                  background: "#e0e0e0",
                  color: "#226c56",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 18px",
                  fontWeight: "bold",
                  fontSize: 14,
                  cursor: "pointer",
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 18 }}>
              <label
                style={{
                  fontWeight: "bold",
                  color: "#226c56",
                  marginRight: 8,
                }}
              >
                Tipo de mensagem:
              </label>
              <select
                value={tipoSelecionado}
                onChange={(e) => {
                  console.log("Tipo selecionado:", e.target.value);
                  setTipoSelecionado(e.target.value);
                }}
                style={{
                  borderRadius: 8,
                  padding: "10px 22px",
                  fontSize: 14,
                  border: "2px solid #25d366",
                  background: "#e8f8f3",
                  color: "#184c3a",
                  fontWeight: "bold",
                  minWidth: 180,
                  outline: "none",
                  boxShadow: "0 2px 8px #25d36622",
                }}
              >
                <option value="">Selecione o tipo...</option>
                {tipos.map((tipo) => (
                  <option key={tipo} value={tipo}>
                    {tipo}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                maxHeight: 320,
                overflowY: "auto",
                paddingRight: 6,
                marginBottom: 4,
              }}
            >
              {tipoSelecionado ? (
                <div>
                  {favoritas.length > 0 && (
                    <div style={{ marginBottom: 8 }}>
                      <div
                        style={{
                          color: "#25d366",
                          fontWeight: "bold",
                          marginBottom: 4,
                          fontSize: 14,
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span style={{ fontSize: 18 }}>★</span> Favoritas
                      </div>
                      {favoritas.map((msg) => (
                        <button
                          key={msg.id}
                          onClick={() => {
                            console.log("Favorita selecionada:", msg.texto);
                            handleSeleciona(msg.texto);
                          }}
                          style={{
                            width: "100%",
                            background: "#25d36622",
                            border: "2px solid #25d366",
                            borderRadius: 10,
                            padding: "12px 14px",
                            fontWeight: "bold",
                            color: "#184c3a",
                            fontSize: 16,
                            cursor: "pointer",
                            marginBottom: 7,
                            textAlign: "left",
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            alignItems: "flex-start",
                            boxShadow: "0 2px 8px #25d36622",
                          }}
                          title={msg.titulo || msg.texto.substring(0, 30)}
                        >
                          <div
                            style={{
                              fontWeight: "bold",
                              color: "#226c56",
                              marginBottom: 4,
                            }}
                          >
                            {msg.titulo || <i>Sem título</i>}
                          </div>
                          <div style={{ fontSize: 13, color: "#555" }}>
                            {msg.texto.length > 60
                              ? msg.texto.substring(0, 60) + "..."
                              : msg.texto}
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                  {comuns.length > 0 && (
                    <div>
                      <div
                        style={{
                          color: "#226c56",
                          fontWeight: "bold",
                          marginBottom: 4,
                          fontSize: 14,
                        }}
                      >
                        Outras mensagens
                      </div>
                      {comuns.map((msg) => (
                        <button
                          key={msg.id}
                          onClick={() => {
                            console.log("Comum selecionada:", msg.texto);
                            handleSeleciona(msg.texto);
                          }}
                          style={{
                            width: "100%",
                            background: "#f6faf8",
                            border: "1px solid #e0e0e0",
                            borderRadius: 10,
                            padding: "12px 14px",
                            fontWeight: "500",
                            color: "#226c56",
                            fontSize: 15,
                            cursor: "pointer",
                            marginBottom: 7,
                            textAlign: "left",
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            alignItems: "flex-start",
                          }}
                          title={msg.titulo || msg.texto.substring(0, 30)}
                        >
                          <div
                            style={{
                              fontWeight: "bold",
                              color: "#226c56",
                              marginBottom: 4,
                            }}
                          >
                            {msg.titulo || <i>Sem título</i>}
                          </div>
                          <div style={{ fontSize: 14, color: "#555" }}>
                            {msg.texto.length > 60
                              ? msg.texto.substring(0, 60) + "..."
                              : msg.texto}
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                  {favoritas.length === 0 && comuns.length === 0 && (
                    <div
                      style={{
                        color: "#999",
                        fontSize: 15,
                        padding: 12,
                        textAlign: "center",
                      }}
                    >
                      Nenhuma mensagem cadastrada para este tipo.
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    color: "#666",
                    fontSize: 15,
                    padding: 10,
                    textAlign: "center",
                  }}
                >
                  Selecione um tipo de mensagem para visualizar.
                </div>
              )}
            </div>
          </>
        ))}
    </div>
  );
}
